import React from 'react';
export function SpecialsSection() {
  return <section className="section-padding bg-warm-50 border-y border-warm-200" data-id="element-290">
      <div className="container-wide" data-id="element-291">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-292">
          <div data-id="element-293">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-2" data-id="element-294">
              This Week's Specials
            </h2>
            <p className="text-lg text-red-600 font-medium flex items-center gap-2" data-id="element-295">
              <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse" data-id="element-296"></span>
              Limited time offers — don't miss out
            </p>
          </div>
          <button className="btn-secondary bg-white" data-id="element-297">View All Specials</button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-298">
          {/* Card 1 */}
          <div className="rounded-2xl overflow-hidden relative group cursor-pointer shadow-card hover:shadow-card-hover transition-all duration-500 h-[300px]" data-id="element-299">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&q=80')] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" data-id="element-300"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-brand-blue-900/90 to-transparent" data-id="element-301"></div>

            <div className="relative z-10 p-8 h-full flex flex-col justify-center w-2/3" data-id="element-302">
              <span className="badge-blue self-start mb-3 bg-white text-brand-blue" data-id="element-303">
                Save 20%
              </span>
              <h3 className="font-heading font-bold text-2xl text-white mb-3 leading-tight" data-id="element-304">
                Premium Dog Food Big Bags
              </h3>
              <button className="text-white font-bold flex items-center gap-2 hover:text-brand-blue-200 transition-colors mt-auto self-start" data-id="element-305">
                Shop Offer <span data-id="element-306">→</span>
              </button>
            </div>
          </div>

          {/* Card 2 */}
          <div className="rounded-2xl overflow-hidden relative group cursor-pointer shadow-card hover:shadow-card-hover transition-all duration-500 h-[300px]" data-id="element-307">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80')] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" data-id="element-308"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-brand-green-900/90 to-transparent" data-id="element-309"></div>

            <div className="relative z-10 p-8 h-full flex flex-col justify-center w-2/3" data-id="element-310">
              <span className="badge-green self-start mb-3 bg-white text-brand-green" data-id="element-311">
                Half Price
              </span>
              <h3 className="font-heading font-bold text-2xl text-white mb-3 leading-tight" data-id="element-312">
                Spring Garden Fertilisers
              </h3>
              <button className="text-white font-bold flex items-center gap-2 hover:text-brand-green-200 transition-colors mt-auto self-start" data-id="element-313">
                Shop Offer <span data-id="element-314">→</span>
              </button>
            </div>
          </div>

          {/* Card 3 */}
          <div className="rounded-2xl overflow-hidden relative group cursor-pointer shadow-card hover:shadow-card-hover transition-all duration-500 h-[300px]" data-id="element-315">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=600&q=80')] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" data-id="element-316"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-900/90 to-transparent" data-id="element-317"></div>

            <div className="relative z-10 p-8 h-full flex flex-col justify-center w-2/3" data-id="element-318">
              <span className="badge-warm self-start mb-3 bg-white text-cyan-700" data-id="element-319">
                Buy 2 Get 1 Free
              </span>
              <h3 className="font-heading font-bold text-2xl text-white mb-3 leading-tight" data-id="element-320">
                Pool Chlorine & Chemicals
              </h3>
              <button className="text-white font-bold flex items-center gap-2 hover:text-cyan-200 transition-colors mt-auto self-start" data-id="element-321">
                Shop Offer <span data-id="element-322">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}